module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/external_url_icon_dark.02c15e55.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/images/external_url_icon_dark.png
// module id = 2896
// module chunks = 11